import { createPersistedState } from '@edreamsodigeo/frontend-core';

export interface FlightSelectionData {
  data: {
    fareItineraryKey: string;
    flightNumbers: string[];
    priceWithoutDiscountSelected: boolean;
    membershipCouponApplied: boolean;
    membershipExtraDiscount: {
      wasExtraDiscountAvailable: boolean;
      wasExtraDiscountSelected: false;
    };
    promotedItineraryTypes: string[];
    searchId: string;
    segmentKeys: number[];
    refundableFareUpgrade: boolean;
    refundableFareUpgradeShown: boolean;
  };
  flightNumbers: string[];
}

export const usePersistedFlightSelection = createPersistedState({
  type: 'sessionStorage',
  key: 'flightSelectionData',
  isGlobal: true,
});
